import { motion } from 'framer-motion';
import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

export const SkillSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 16px 10px;

  ${({ theme }) =>
    theme.isError &&
    `
    padding: 15px 9px;
    border: 1px solid var(--color-error);
  `}

  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);

  cursor: pointer;
  position: relative;
`;

export const SkillSelectInput = styled.input`
  flex: 1;

  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: normal;

    color: var(--color-data-alumni-background);
  }

  color: var(--color-text);
`;

export const SkillSelectIconContainer = styled.div`
  min-width: 44px;
  min-height: 44px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
`;

export const SkillSelectOptionsContainer = styled(motion.div).attrs({
  animate: { maxHeight: 200 },
  initial: { maxHeight: 0 },
  exit: { maxHeight: 0 },
})`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  border-radius: 0px 0px 8px 8px;

  background: #ffffff;

  transform: translateY(calc(100% - 4px));

  overflow: auto;
  z-index: 2;

  & > :last-child {
    padding-bottom: 19px;
  }
`;

export const SkillSelectOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 3px 24px 3px 18px;

  &:hover {
    background: #f5f5f5;
  }
`;

interface SkillSelectOptionLabelProps {
  alreadyAdded?: boolean;
}

export const SkillSelectOptionLabel = styled.span<SkillSelectOptionLabelProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: normal;

  color: ${({ alreadyAdded }) => (alreadyAdded ? 'rgba(23, 28, 51, 0.5)' : 'var(--color-text)')};
`;

export const SkillSelectOptionAdd = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);

  padding: 2px 8px;
  border-radius: 16px;
  background: #ffc229;
`;

export const SkillSelectOptionAlreadyAdded = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

// SELECTED CLIENT
export const SkillSelectSelectedSkillsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;

  overflow-x: auto;

  scrollbar-width: thin;
  scrollbar-gutter: stable;
`;

export const SkillSelectSelectedSkillContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 24px;

  border-radius: 50px;
  background: var(--color-data-skill-background);

  & > [data-action='remove'] {
    display: none;

    ${BREAKPOINTS.tablet} {
      display: flex;
    }
  }

  & > svg:first-child {
    mix-blend-mode: multiply;
  }

  &:hover {
    background: var(--color-data-skill-background-hover);
    padding: 8px 6px 8px 24px;

    & > [data-action='remove'] {
      display: flex;
    }

    ${BREAKPOINTS.tablet} {
      padding: 4px 12px;
      background: var(--color-data-skill-background);
    }
  }

  ${BREAKPOINTS.tablet} {
    padding: 4px 12px;
  }
`;

interface SkillSelectSelectedSkillLabelProps {
  loading?: boolean;
}

export const SkillSelectSelectedSkillLabel = styled.span<SkillSelectSelectedSkillLabelProps>`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  text-wrap: nowrap;

  color: var(--color-text);

  ${({ loading }) =>
    loading &&
    `
    width: 64px;

    display: flex;
    align-items: center;
    justify-content: center;
    
    `}
  & > svg {
    ${infiniteRotationAnimation('1s')}
  }
`;

export const SkillSelectSelectedSkillRemoveContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;
